import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../../app/api/routes';
import { PRINCIPAL_RESOURCE, PRINCIPALS_RESOURCE } from '../../constants';

const ACTIVATE_PRINCIPAL_RESOURCE = 'activatePrincipal';

const ActivatePrincipalService = ComposedComponent =>
  reduxFetch([
    {
      resource: ACTIVATE_PRINCIPAL_RESOURCE,
      method: 'post',
      request: (id, organisationId, callback, t) => ({
        url: apiRoutes.activatePrincipal(id),
        meta: {
          callback,
          updateOtherList: {
            resource: `${PRINCIPALS_RESOURCE}_${organisationId}`,
            idProp: 'id',
            id,
          },
          setOther: {
            resource: PRINCIPAL_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'activatePrincipalFailed'),
            onSuccessMessage: t('activatePrincipalSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default ActivatePrincipalService;
